import * as React from "react"
import styled from 'styled-components';
import bannerimage from '../../../images/banner1.jpg';
import { Button } from "react-bootstrap";
import { useConfig } from "../../../hooks/use-config"
import AccuracyTextTooltip from "../../accuracy-text-with-tooltip"

const StyledHeroContainer = styled("div")`
 .hero {
    // background: url(${bannerimage});
    background-image: linear-gradient(to right bottom,#051937,#004d7a,#155055,#135f40,#567512) !important;
    width: 100%;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    height: 450px;
    margin-top:-40px
  }
  p{
    text-align: center;
    color: #000000; 
    font-size: 20px; 
    color: #dfda95; 
    font-weight: 400;
  }

`
const Hero = () => {
    const { clearout: clearoutConfig } = useConfig()

    return (
        <StyledHeroContainer>
            <div className="mw-100 hero">
                <div className="text-center mt-5 py-5">
                    <h1 className="mb-4 fw-bolder text-white">Clearout Vs Dropcontact</h1>
                    <h2 className="text-white pb-4">The Ultimate Comparison</h2>
                    <p>Clearout, a globally used Solution <AccuracyTextTooltip/> Accuracy &gt;&gt; 10x Faster Turnaround Time &gt;&gt; 24*7 Support</p>
                    <Button href={clearoutConfig.app.registerUrl} target="_blank" className="btn btn-primary btn-free-credits fw-bold px-4">Sign Up & Get 100 Free credits</Button>
                    <p className="text-white fs-6">No Credit Card Required</p>
                </div>
            </div>
        </StyledHeroContainer>
    )
}

export default Hero;